import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { GeoAreaType } from 'src/app/assabil-kernel/models/entities/control-tables/geo-area-type-entity';
import { GeoAreaTypeRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/geo-area-type-request';


@Component({
  selector: 'geoarea-type-list',
  templateUrl: './geoarea-type-list.component.html',
  styleUrls: ['./geoarea-type-list.component.scss']
})

export class GeoAreaTypeListComponent extends BasePage2<GeoAreaType> {


  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  geoAreaTypes: GeoAreaType[] = [];
  // ---------------------------------------------------
  
  // ---------------------------------------------------

  constructor(
      protected toastr                : ToastrService,
      protected router                : Router,
      protected baseService           : BaseService,
      protected leanUtilsService      : LeanUtilsService,
      protected controlTablesService  : ControlTablesService,
      protected location              : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName =  "geoAreaType";
  }
  // ---------------------------------------------------

    
  // ---------------------------------------------------
  getRows(): GeoAreaType[] {
      return this.geoAreaTypes;
  }
  // ---------------------------------------------------


//----------------------------------------------------------------------
saveRow(row: GeoAreaType): Promise<GeoAreaType> {
    let request: GeoAreaTypeRequest = new GeoAreaTypeRequest(this.controlTablesService.getUserInfo());
    request.geoAreaType = row;
    return this.controlTablesService.save(this.entityName, request);
}
//----------------------------------------------------------------------

  
//----------------------------------------------------------------------
  new(){
      let entity : GeoAreaType = new GeoAreaType();
      entity.inserted = true;
      entity.edit = true;
      this.geoAreaTypes.push(entity);
      this.geoAreaTypes = [...this.geoAreaTypes];
    }
//----------------------------------------------------------------------

        
//----------------------------------------------------------------------
  loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.geoAreaTypes = result;
    })
  }
  // ---------------------------------------------------

}